import { CommonAppState, NotificationsState } from '@bd/store-modules/types'
import { Module } from 'vuex'
import { actions } from './actions'
import { mutations } from './mutations'
import { state } from './state'

const staticData: Module<NotificationsState, CommonAppState> = {
  namespaced: true,
  state,
  mutations,
  actions,
}

export default staticData
